<template>
    <div class="cv3-stepper">
        <button type="button" class="cv3-step minus" :disabled="disabled || value <= min" @click="dec">
            <MinusIcon :size="15" />
        </button>
        <input
            ref="input"
            type="number"
            class="cv3-step-val"
            :value="displayValue"
            :min="min"
            :disabled="disabled"
            @click="onFocus"
            @change="onChange"
            @keyup.enter="onChange"
            @keyup.escape="onEscape"
            @focus="onFocus"
            @blur="onBlur"
        />
        <button type="button" class="cv3-step plus" :disabled="disabled" @click="inc">
            <PlusIcon :size="15" />
        </button>
    </div>
</template>

<script>
import { Minus as MinusIcon, Plus as PlusIcon } from 'lucide-vue'

export default {
    name: 'QuantityStepper',
    components: { MinusIcon, PlusIcon },
    props: {
        value: { type: Number, default: 1 },
        min: { type: Number, default: 1 },
        disabled: { type: Boolean, default: false },
    },
    data() {
        return {
            editing: false,
            draft: null,
        }
    },
    computed: {
        displayValue() {
            if (this.editing && this.draft !== null) return this.draft
            return this.value
        },
    },
    methods: {
        inc() {
            this.$emit('inc')
            this.$emit('input', this.value + 1)
        },
        dec() {
            if (this.value <= this.min) return
            this.$emit('dec')
            this.$emit('input', this.value - 1)
        },
        onFocus(e) {
            this.editing = true
            this.draft = this.value
            this.$nextTick(() => e.target.select())
        },
        onChange(e) {
            if (!this.editing && this.draft === null) return
            const raw = parseInt(e.target.value, 10)
            const valid = isNaN(raw) ? this.min : Math.max(this.min, raw)
            this.editing = false
            this.draft = null
            if (valid !== this.value) {
                this.$emit('change', valid)
                this.$emit('input', valid)
            } else {
                e.target.value = this.value
            }
        },
        onEscape() {
            this.editing = false
            this.draft = null
            if (this.$refs.input) this.$refs.input.value = this.value
        },
        onBlur(e) {
            if (this.editing) this.onChange(e)
        },
    },
}
</script>

<style scoped lang="scss">
.cv3-stepper {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}
.cv3-step {
    width: 31px;
    height: 31px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    border: 1px solid var(--cv3-border-input);
    background: transparent;
    color: var(--cv3-text-2);
    &.plus {
        border: 0;
        background: var(--cv3-accent);
        color: #fff;
    }
}
.cv3-step-val {
    min-width: 24px;
    width: 36px;
    height: 31px;
    text-align: center;
    font-weight: 800;
    font-size: 14px;
    color: #fff;
    background: rgba(125, 45, 189, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 10px;
    outline: none;
    padding: 0;
    -moz-appearance: textfield;
    appearance: none;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    &:focus {
        border-color: #c398e6;
        box-shadow: 0 0 0 3px rgba(171, 110, 220, 0.35);
        outline: none;
    }
    &:disabled {
        opacity: 0.6;
    }
}
</style>
